import { AdvisorDetailsPage, Auth } from 'components'

export const Add = () => {
  return (
    <Auth>
      <AdvisorDetailsPage />
    </Auth>
  )
}
